import { render, staticRenderFns } from "./SupplierEditor.vue?vue&type=template&id=18841d15&scoped=true&"
import script from "./SupplierEditor.vue?vue&type=script&lang=js&"
export * from "./SupplierEditor.vue?vue&type=script&lang=js&"
import style0 from "./SupplierEditor.vue?vue&type=style&index=0&id=18841d15&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18841d15",
  null
  
)

export default component.exports